// Canonical PTG standards — keep in sync with backend STANDARDS in server.py
export const STANDARDS = [
  "Nursery", "Jr. KG", "Sr. KG",
  "Std 1", "Std 2", "Std 3", "Std 4", "Std 5", "Std 6",
  "Std 7", "Std 8", "Std 9", "Std 10", "Std 11", "Std 12",
  "Degree",
];
